import { Card, Grid, Skeleton } from '@mui/material';

import styles from './CookingHistoryEditSkeleton.module.css';

const CookingHistoryEditSkeleton = () => (
  <Grid className={styles.container}>

    <Card className={styles.recipeRatingSection}>
      <Grid className={styles.titleSection}>
        <Skeleton className={styles.titleSkeleton} variant="text" />
      </Grid>

      <Grid className={styles.recipeSection}>
        <Skeleton className={styles.ratingTextSkeleton} variant="text" />
        <Skeleton className={styles.dishImageSkeleton} variant="rectangular" />
      </Grid>
    </Card>

    <Grid className={styles.mainFeedbackSection}>
      <Card className={styles.optionsSection}>
        <Grid className={styles.feedbackSkeleton}>
          {[1, 2, 3, 4, 5, 6].map((item) => (
            <Skeleton className={styles.feedbackOptionSkeleton} key={item} variant="text" />
          ))}
        </Grid>
      </Card>
      <Card className={styles.commentSection}>
        <Grid>
          <Skeleton className={styles.reviewTextSkeleton} variant="rectangular" />
        </Grid>

        <Grid>
          <Skeleton className={styles.uploadButtonSkeleton} variant="rectangular" />
        </Grid>
      </Card>
      <Card className={styles.submitSection}>
        <Skeleton className={styles.submitButtonSkeleton} variant="rectangular" />
      </Card>
    </Grid>

  </Grid >
);

export default CookingHistoryEditSkeleton;
